"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubHorizonInvestissement = void 0;
exports.ESubHorizonInvestissement = {
    between_1_5_ans: "between_1_5_ans",
    between_5_10_ans: "between_5_10_ans",
    greater_10_ans: "greater_10_ans",
};
